import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/bookings/bookings-client.tsx");
